import { useState, useEffect, useCallback, useRef } from "react";
import http from "../network/http";

const useFetchData = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const controllerRef = useRef(null);
  const pendingRequests = useRef(0);

  const updateCacheData = useCallback(function (callback) {
    setData((preData) => {
      const newData = callback(preData);
      console.log("newData");
      console.log(newData);
      return newData;
    });
  }, []);

  const fetchData = useCallback(async (url, onRequest, onResponse) => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    let controller = new AbortController();
    controllerRef.current = controller;
    let signal = controller.signal;

    try {
      setLoading(true);
      setError(null);
      pendingRequests.current++;

      // 请求前回调
      onRequest && onRequest();

      const response = await http.fetch(url, { signal });
      if (!response.ok) {
        throw new Error("数据请求失败");
      }
      const responseData = await response.json();
      if (controller.signal.aborted) {
        return; // 请求取消了
      }
      onResponse && onResponse(responseData);
      setData(responseData);
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        setError(error);
      }
    } finally {
      pendingRequests.current--;
      if (pendingRequests.current === 0) {
        setLoading(false);
      }
    }
  }, []);

  // 组件卸载时取消未完成的请求
  useEffect(() => {
    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, []);

  return { data, loading, error, fetchData, updateCacheData };
};

export default useFetchData;
